<template>
  <NuxtLink
    v-if="path && (!isTab ||isEnabled)"
    class="flex items-center space-x-4 rtl:space-x-reverse p-3 hover:bg-action hover:text-action transition-all text-[var(--bookapp-hero-text-color)] cursor-pointer rounded"
    :class="[ isActive ? 'text-primary bg-primary/20' : 'text-secondary opacity-75' ]"
    :to="path"
  >
    <LayoutElementsIcon :name="item.icon || icons[item.id]" class="flex-shrink-0"/>
    <div>
      <p class="text-sm">{{ name }}</p>
      <p v-if="information" class="text-sm opacity-70">{{ information }}</p>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()
const route = useRoute()

interface Props {
  item: {
    id: keyof typeof paths
    name: string
    type: string
    slug: string
    icon: string
    information: string
  }
}

const props = defineProps<Props>()

const paths = {
  book: "/book-now",
  timetable: "/timetable",
  lastMinute: "/last-minute",
  giftCard: "/gift",
  pass: "/pass",
  gallery: "/gallery",
  review: "/reviews",
  user: "/customer"
}

const icons = {
  book: "clock",
  timetable: "calendar-days",
  lastMinute: "bell-alert",
  giftCard: "gift",
  pass: "ticket",
  gallery: "photo",
  review: "star",
  user: "user"
}

const name = computed(() => {
  return props.item?.name || $site.tabs.getName(props.item?.id, props.item?.id)
})

const path = computed(() => {
  if (props.item?.type === 'custom') {
    return `/page/${props.item?.slug}`
  }

  return paths[props.item?.id]
})

const information = computed(() => {
  return props.item.information
})

const isActive = computed(() => {
  return route.path.includes(path.value)
})

const isEnabled = computed(() => {
  return !!$site.tabs[props.item?.id]
})

const isTab = computed(() => {
  return props.item?.type === 'tab'
})
</script>